/**
 * Code for Progress Bar
 */
export const STEPBAR_INITIALIZE = 'STEPBAR_INITIALIZE';
export const STEPBAR_REINITIALIZE = 'STEPBAR_REINITIALIZE';
export const STEPBAR_GO_PREVIOUS_STEP = 'STEPBAR_GO_PREVIOUS_STEP';
export const STEPBAR_SAVE_AND_NEXT = 'STEPBAR_SAVE_AND_NEXT';
export const STEPBAR_EDIT_PREVSTEP = 'STEPBAR_EDIT_PREVSTEP';
export const STEPBAR_INIT_ON_ROUTE = 'STEPBAR_INIT_ON_ROUTE';
export const STEPBAR_SAVE_SELECTION_VALUE = 'STEPBAR_SAVE_SELECTION_VALUE';
export const STEPBAR_PUT_VALUE_ON_STEP = 'STEPBAR_PUT_VALUE_ON_STEP';
export const STEPBAR_SAVE_SELECTION_VALUE_ON_MODAL = 'STEPBAR_SAVE_SELECTION_VALUE_ON_MODAL';
export const STEPBAR_DISMISS_MODAL = 'STEPBAR_DISMISS_MODAL';
export const STEPBAR_PUT_VALUE_ON_OTHER = 'STEPBAR_PUT_VALUE_ON_OTHER';
export const STEPBAR_STATE_REINIT = 'STEPBAR_STATE_REINIT';


export const LOBDATA_SAVE_SELECTED_VEHICLE = 'LOBDATA_SAVE_SELECTED_VEHICLE';
export const LOBDATA_SAVE_OP_APP_COLUMN_NAME = 'LOBDATA_SAVE_OP_APP_COLUMN_NAME';
export const STEPBAR_SAVE_LOB = 'STEPBAR_SAVE_LOB'
export const LOBDATA_SAVE_SELECTED_VALUE = 'LOBDATA_SAVE_SELECTED_VALUE'
export const LOBDATA_SET_VC_NO = 'LOBDATA_SET_VC_NO'
export const LOBDATA_RESET_VC_NO = 'LOBDATA_RESET_VC_NO'
export const SAVE_SEARCH_TYPE = 'SAVE_SEARCH_TYPE'
export const LOBDATA_STATE_REINIT = 'LOBDATA_STATE_REINIT';
export const SAVE_VEHICLE_PL = 'SAVE_VEHICLE_PL'

export const RESET_ALL_STATE = 'RESET_ALL_STATE';







